import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, MapPin, Clock } from 'lucide-react';

const Header = () => {
  const phoneNumber = '+4923139085116';
  const displayPhone = '0231 39085116';
  const whatsappLink = `https://wa.me/4923139085116?text=Hallo, ich benötige Hilfe beim Schlüsseldienst`;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-orange-500 to-amber-400 text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-between items-center text-sm">
            <div className="flex items-center gap-4">
              <span className="flex items-center gap-1">
                <Clock size={16} />
                <span className="hidden sm:inline">24/7 Notdienst</span>
              </span>
              <span className="flex items-center gap-1">
                <MapPin size={16} />
                <span>Ganz Dortmund</span>
              </span>
            </div>
            <div className="flex gap-3">
              <a
                href={`tel:${phoneNumber}`}
                className="flex items-center gap-1 hover:underline font-medium"
                data-testid="header-phone-link"
              >
                <Phone size={16} />
                <span>{displayPhone}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/schluesseldienst-dortmund" className="text-2xl font-bold text-orange-600" data-testid="logo-link">
            Schlüsseldienst.services
          </Link>
          
          <nav className="hidden md:flex gap-6" data-testid="main-nav">
            <Link to="/schluesseldienst-dortmund" className="hover:text-orange-600 transition-colors">Start</Link>
            <Link to="/leistungen" className="hover:text-orange-600 transition-colors">Leistungen</Link>
            <Link to="/preise" className="hover:text-orange-600 transition-colors">Preise</Link>
            <Link to="/einsatzgebiete" className="hover:text-orange-600 transition-colors">Einsatzgebiete</Link>
            <Link to="/ratgeber" className="hover:text-orange-600 transition-colors">Ratgeber</Link>
          </nav>

          <div className="flex gap-2">
            <a
              href={`tel:${phoneNumber}`}
              className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-full font-semibold transition-all shadow-md hover:shadow-lg flex items-center gap-2"
              data-testid="header-cta-call"
            >
              <Phone size={18} />
              <span className="hidden sm:inline">Anrufen</span>
            </a>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full font-semibold transition-all shadow-md hover:shadow-lg flex items-center gap-2"
              data-testid="header-cta-whatsapp"
            >
              <MessageCircle size={18} />
              <span className="hidden sm:inline">WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
